function WdWidgetsApi (langId, proxyUrl, conf) {
	var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	conf = conf || {};
	conf.marketingParams = true;
	if (window.ReactNativeWebView) {
		conf.embed3rdParties = false;
		conf.trafficSource = 'Mobile';
	} else {
		conf.trafficSource = isMobile ? 'MobileWeb': 'Web';
	}
	this.widgetLoader = Scipio.getLoader(langId, proxyUrl, conf);
}

/**
 *
 * @param errorSelector - wrapper for error template
 * @param showNewStyle (optional) - if set to true then the new server general popup will show
 * @param formCoverCustomSelector (optional) - string that if is set it will contian the selector that will contain the form cover instead of the errorSelector in the first arg
 * @param exitCallback (callback) - function to run when closing the server messeage instead of the default hide serve msg
 * @returns {{showServerMessages: showServerMessages, processServerMessages: processServerMessages, hideLoader: hideLoader, hideServerMessages: hideServerMessages, showLoader: showLoader}}
 */
function processForm ( errorSelector , showNewStyle , formCoverCustomSelector , exitCallback ) {

	var $widgetParent = $( errorSelector );
	showNewStyle = (showNewStyle === true) ;

	var serverMessagesConfig = {
		resultElement: $( errorSelector + ' .error-input, #mobileErrForm .error-input' ),
		errorWrapper: $(errorSelector + ' .form-error, #mobileErrForm' ),
		loadingBar: $(errorSelector + ' .loading-bar' ),
		formCover: $(errorSelector + ' .form-cover-wizard , ' + errorSelector  + ' .form-cover' ),
		closeErrorBtn: $(errorSelector + ' .close-error-btn, #mobileErrForm .close-error-btn' ),
		newErrorInsertSelector : $( errorSelector +  ' .new-error-msg-style'),
		formCoverCustomSelector : !! formCoverCustomSelector ?  $(formCoverCustomSelector) : false,
		exitCallback : typeof exitCallback === 'function' ? exitCallback : false
	};

	function showLoader () {
		$( getFormCover() ).addClass( 'active' );
		$( serverMessagesConfig.loadingBar ).show();
		$( serverMessagesConfig.errorWrapper ).hide();
		$( serverMessagesConfig.resultElement ).html( "" );
	}

	function hideLoader () {
		$( serverMessagesConfig.loadingBar ).hide();
	}

	function hideServerMessages () {
		$( serverMessagesConfig.loadingBar ).hide();
		$( serverMessagesConfig.errorWrapper ).hide();
		$( getFormCover() ).removeClass( 'active' );

		if ($( window ).width() < 991) {
			$( '#popup-wizard' ).css( {
				overflow: 'auto', height: 'auto'
			} );
			$("body").removeAttr("style");
		}
	}

	function showServerMessages ( errorText , exitCallback ) {
		$( serverMessagesConfig.loadingBar ).hide();
		$(getFormCover() ).addClass( 'active' );
		$( serverMessagesConfig.resultElement ).html( errorText );
		$( serverMessagesConfig.errorWrapper ).show();

		if ($( window ).width() < 991) {
			$( '#popup-wizard, body' ).css( {
				overflow: 'hidden', height: '100%'
			} );
		}

		var that = this;
		$( serverMessagesConfig.closeErrorBtn.selector ).on( 'click', function () {
			that.hideServerMessages();
			if ( typeof (exitCallback) == 'function' ){
				exitCallback(errors);
			}
		} );
	}

	function processNewStyleServerMessages(errors){
		if(!errors) return;

		var errorCode = errors[0].Code || null;

		if (errorCode == "ValidationEx") {
			hideServerMessages();
		} else {
			var errorText = errors[0].Message;
			$(serverMessagesConfig.loadingBar).hide();
			var conf = {
				insertSelector: serverMessagesConfig.newErrorInsertSelector,
				formCoverSelector: getFormCover(),
				btnsColor: {
					closeBtn: 'theme'
				},
				content: errorText,
				title : newErrorPopup.title,
				hideBtn: newErrorPopup.okBtn,
				onHideArgs: errors
			};
			if(serverMessagesConfig.exitCallback){
				conf.onHideCallback = exitCallback ;
			}
			msg_popup_render(conf);
		}
	}

	function processServerMessages ( errors, showFormCover) {
		if(!errors) return;

		var errorCode = errors[ 0 ].Code;
		var errorText = errors[ 0 ].Message;

		if (errorCode == "ValidationEx") {
			hideServerMessages();
		} else {
			if (!!showFormCover) {
				$( serverMessagesConfig.formCover ).addClass( 'active' );
			}
			if(typeof showNewStyle !== 'undefined' && showNewStyle === true){
				processNewStyleServerMessages(errors);
			}
			else{
				this.showServerMessages(errorText, serverMessagesConfig.exitCallback);
			}
		}
	}

	function getFormCover () {
		return serverMessagesConfig.formCoverCustomSelector ||  serverMessagesConfig.formCover;
	}


	return {
		showLoader: showLoader,
		hideLoader: hideLoader,
		hideServerMessages: hideServerMessages,
		showServerMessages: showServerMessages,
		processServerMessages: processServerMessages
	};
}

/**
 *
 * @param widgetName string
 * @param placeholder string
 * @param conf object : widget conf callbacks
 * @param additionalConf object optional : {errorWrapper : 'selector containing error and loader template'}
 */
WdWidgetsApi.prototype.loadAndRender = function ( widgetName, placeholder, conf, additionalConf ) {

	var _conf = {
		onSuccess: conf.onSuccess, onError: conf.onError, onSubmit: conf.onSubmit, onLoad: conf.onLoad, onExitError : conf.onExitError,
	};

	additionalConf = additionalConf ? additionalConf: {};

	var errorSelector = ( typeof additionalConf == 'object' && !!additionalConf.errorWrapper ) ? additionalConf.errorWrapper : false;
	var processFormObj = processForm( errorSelector  , additionalConf.showNewStyle ? additionalConf.showNewStyle : false , additionalConf.formCoverCustomSelector, additionalConf.exitCallback);


	function success ( results ) {
		if (!!_conf.onSuccess) {
			var ret = _conf.onSuccess.apply( null, arguments );
			if (ret === false){
				return false;
			}
		}
		processFormObj.hideServerMessages();
		processFormObj.hideLoader();
		$('body').trigger('sw.widget-success', [widgetName, placeholder, conf]);
	}

	function error ( errors ) {
		if(!errors) return;

		if (errors[0].Code == 'AutenticationEX') {
			if(typeof setLoginObject == 'function'){
				window.loginCallbackSuccessfunc = 'refresh' ;
				$( '#login-popup' ).modal( 'show' );
			}
		}

		if (errors[0].Code == 'RegulationEx') {
			window.location.reload();
			return;
		}

		if (!!_conf.onError) {
			var ret = _conf.onError.apply( null, arguments );
			if (ret === false) {
				return;
			}
		}

		processFormObj.hideLoader();
		processFormObj.processServerMessages( errors );
		//processFormObj.disableEnableButtons();
		if (!!_conf.onExitError) {
			var ret = _conf.onExitError.apply( null, arguments );
			if (ret === false) {
				return;
			}
		}
		$('body').trigger('sw.widget-error', [widgetName, placeholder, conf, errors]);
	}

	function submit () {
		processFormObj.showLoader();
		if (!!_conf.onSubmit) {
			_conf.onSubmit.apply( null, arguments );
		}
		$('body').trigger('sw.widget-submit', [widgetName, placeholder, conf]);
	}

	function load () {
		processFormObj.hideServerMessages();
		processFormObj.hideLoader();
		if (!!_conf.onLoad) {
			_conf.onLoad.apply( null, arguments );
		}
		$('body').trigger('sw.widget-load', [widgetName, placeholder, conf]);
	}

	conf.onSuccess = success;
	conf.onError = error;
	conf.onSubmit = submit;
	conf.onLoad = load;
	delete conf.onExitError;


	// only if the widget doesn't exist in the placeholder then render it
	if ($.trim( $( '#' + placeholder ).html() ) === '') {
		return this.widgetLoader.loadAndRender( widgetName, placeholder, conf );
	}
};


WdWidgetsApi.prototype.resetWidgetFields = function ( placeholder ) {


};


/*
 1. on submit : add loader
 2. on load : hide loader
 3. on failure : hide loader , centralize all the bubble error vitaly api to here
 4. success: sbroker update
 */